// extracted by mini-css-extract-plugin
module.exports = {"button":"IppicaTicketActionScommetti_button__e5fR4","disable":"IppicaTicketActionScommetti_disable__Vr7mY"};